import React from "react";

const Popular = () => <p>Popular</p>;

export default Popular;
